module.exports = __webpack_public_path__ + "static/media/AWS-SolArchitect-Associate.c041404a.png";